import { render, staticRenderFns } from "./LgFinderPageTipoFiscal.vue?vue&type=template&id=4e2e1854"
import script from "./LgFinderPageTipoFiscal.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoFiscal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports